import { render } from "./OpenActivity.vue?vue&type=template&id=a4414b3e&scoped=true"
import script from "./OpenActivity.vue?vue&type=script&lang=js"
export * from "./OpenActivity.vue?vue&type=script&lang=js"

import "./OpenActivity.vue?vue&type=style&index=0&id=a4414b3e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4414b3e"]])

export default __exports__